import ApiService from "@/common/api/api.service";

let endpoint = "Proposta";

const CronogramaEtapa = {
    
    setEndpoint(endpointSelecionado) {
        endpoint = endpointSelecionado;
    },

    salvar(form, force = false) {
        if(form.cronogramaEtapaId && !force) {
            return ApiService.put(`${endpoint}/cronograma-etapa`, form);
        }else{
            return ApiService.post(`${endpoint}/cronograma-etapa`, form);
        }
    },

    deletar(form) {
        return ApiService.delete(`${endpoint}/cronograma-etapa`, form);
    },

    buscar(id) {
        return ApiService.get(`${endpoint}/cronograma-etapa?propostaId=${id}`);
    }
}

export default CronogramaEtapa;
